export const branches = [
  {
    dep_id: 1389,
    code: "ALM",
    full_name:
      'Алматинский Городской Филиал  Акционерного Общества "Банк ЦентрКредит"',
    name: "Алматы",
    order: 1,
    dep_code: "OPR",
  },
  {
    dep_id: 1444,
    code: "AOF",
    full_name:
      'Алматинский областной филиал Акционерного общества "Банк ЦентрКредит"',
    name: "Алматинский областной филиал",
    order: 2,
    dep_code: "FQ1",
  },
  {
    dep_id: 1411,
    code: "AST",
    full_name:
      'Филиал Акционерного Общества "Банк ЦентрКредит" в городе Астана',
    name: "Астана",
    order: 3,
    dep_code: "OPA",
  },
  {
    dep_id: 1397,
    code: "AKT",
    full_name: 'Филиал Акционерного Общества "Банк ЦентрКредит" в городе Актау',
    name: "Актау",
    order: 4,
    dep_code: "OPJ",
  },
  {
    dep_id: 1399,
    code: "ATB",
    full_name:
      'Филиал Акционерного Общества "Банк ЦентрКредит" в городе Актобе',
    name: "Актобе",
    order: 5,
    dep_code: "OPL",
  },
  {
    dep_id: 1396,
    code: "ATR",
    full_name:
      'Филиал Акционерного Общества "Банк ЦентрКредит" в городе Атырау',
    name: "Атырау",
    order: 6,
    dep_code: "AOP",
  },
  {
    dep_id: 1402,
    code: "GZK",
    full_name:
      'Филиал Акционерного Общества "Банк ЦентрКредит" в области Ұлытау  ',
    name: "Жезказган",
    order: 7,
    dep_code: "ZHU",
  },
  {
    dep_id: 1439,
    code: "KAR",
    full_name:
      'Филиал Акционерного Общества "Банк ЦентрКредит" в городе Караганда',
    name: "Караганда",
    order: 8,
    dep_code: "OPK",
  },
  {
    dep_id: 1441,
    code: "KOK",
    full_name:
      'Филиал Акционерного Общества "Банк ЦентрКредит" в городе Кокшетау',
    name: "Кокшетау",
    order: 9,
    dep_code: "OPI",
  },
  {
    dep_id: 1440,
    code: "KOS",
    full_name:
      'Акционерное Общество "Банк ЦентрКредит" филиал в городе Костанай',
    name: "Костанай",
    order: 10,
    dep_code: "SOK",
  },
  {
    dep_id: 1437,
    code: "KZO",
    full_name:
      'Филиал Акционерного Общества "Банк ЦентрКредит" в городе Кызылорда',
    name: "Кызылорда",
    order: 11,
    dep_code: "KZA",
  },
  {
    dep_id: 1405,
    code: "PVL",
    full_name:
      'Филиал Акционерного Общества "Банк ЦентрКредит" в городе Павлодар',
    name: "Павлодар",
    order: 12,
    dep_code: "POP",
  },
  {
    dep_id: 1408,
    code: "PTR",
    full_name:
      'Филиал Акционерного Общества "Банк ЦентрКредит" в городе Петропавловск',
    name: "Петропавловск",
    order: 13,
    dep_code: "OPP",
  },
  {
    dep_id: 1401,
    code: "SMP",
    full_name: 'Филиал Акционерного Общества "Банк ЦентрКредит" в области Абай',
    name: "Семей",
    order: 14,
    dep_code: "SMU",
  },
  {
    dep_id: 1394,
    code: "TLD",
    full_name:
      'Филиал Акционерного Общества "Банк ЦентрКредит" в области Жетісу',
    name: "Талдыкорган",
    order: 15,
    dep_code: "TL9",
  },
  {
    dep_id: 1393,
    code: "TRZ",
    full_name: 'Филиал Акционерного Общества "Банк ЦентрКредит" в городе Тараз',
    name: "Тараз",
    order: 16,
    dep_code: "OPT",
  },
  {
    dep_id: 7840,
    code: "FTO",
    full_name:
      'Филиал Акционерного Общества "Банк ЦентрКредит" в Туркестанской области',
    name: "Туркестан",
    order: 17,
    dep_code: "FT4",
  },
  {
    dep_id: 1400,
    code: "URL",
    full_name:
      'Филиал Акционерного Общества "Банк ЦентрКредит" в городе Уральск',
    name: "Уральск",
    order: 18,
    dep_code: "UOP",
  },
  {
    dep_id: 1398,
    code: "UST",
    full_name:
      'Филиал Акционерного Общества "Банк ЦентрКредит" в городе Усть-Каменогорск',
    name: "Усть-Каменогорск",
    order: 19,
    dep_code: "OPU",
  },
  {
    dep_id: 1407,
    code: "SMK",
    full_name:
      'Филиал Акционерного Общества "Банк ЦентрКредит" в городе Шымкент',
    name: "Шымкент",
    order: 20,
    dep_code: "OPS",
  },
];
